
import store from '../store/store';
import { ISavedAddressType } from '../types';
import { firebase } from '../config/firebase.client';
import { onValue, remove, push, off } from "firebase/database";
import { EDIT_ADDRESS, FETCH_ADDRESSES, FETCH_ADDRESSES_FAILED, FETCH_ADDRESSES_SUCCESS, } from "../store/types";

export const fetchAddresses = () => (dispatch: any) => {

  const { addressEditRef } = firebase;

  dispatch({
    type: FETCH_ADDRESSES,
    payload: null
  });

  const userInfo = store.getState().auth.profile;
  off(addressEditRef(userInfo.uid));
  onValue(addressEditRef(userInfo.uid), snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_ADDRESSES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ADDRESSES_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_address
      });
    }
  });
};

export const editAddress = (userId: string | undefined, address: ISavedAddressType, method: "Add" | "Delete") => async (dispatch: any) => {

  if (!userId) return;

  const {
    addressRef,
    addressEditRef,
  } = firebase;
  dispatch({
    type: EDIT_ADDRESS,
    payload: { method, address }
  });
  if (method === 'Add') {
    push(addressEditRef(userId), address);
  } else if (method === 'Delete') {
    address.id && remove(addressRef(userId, address.id));
  }
}